import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import learnKaruta from "../assets/img/jeong123456789.png";
import teacher from "../assets/img/teacher.png";
import "./IntroducePage.css";
import title from "../assets/img/title3.png"
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import Swal from "sweetalert2";
import "swiper/css"; //basic
import "swiper/css/navigation";
import "swiper/css/pagination";
import { setTrue } from "../features/bgm/BgmSlice";
import umeki1 from "../assets/img/jeong12345678.png"
import umeki2 from "../assets/img/jeong123.png"
import Lottie from "lottie-react";
import mute from "../assets/mute.json"
import unmute from "../assets/unmute.json"
const IntroducePage = ({ play, windowSize, isBgmOn, setIsBgmOn }) => {
    const navigate = useNavigate();
    const dispatcher = useDispatch();
    const bgmFlg = useSelector((store) => store.bgm);
    const [openModal, setOpenModal] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const bgmSelector = useSelector((store) => store.bgm);
    const handleModalClose = () => {
        dispatcher(setTrue());
        setOpenModal(false);
    };

    const isWide = useMediaQuery({ query: "(min-width: 600px)" });
    const isLong = useMediaQuery({ query: "(min-height: 630px)" });
    const isHeightLongerThanWidth = windowSize.height >= windowSize.width;
    useEffect(() => {
        if (!bgmSelector) {
            const modal = Swal.fire({
                title: "お願い",
                text: "音声をONにしてください。",
                icon: "success",
                confirmButtonColor: "#3085d6", //빨간색
                confirmButtonText: "はい",
                // reverseButtons: true // 버튼 순서 거꾸로
            }).then((result) => {
                dispatcher(setTrue());
              
            });
        } else {
        }
    }, []);
    useEffect(() => {
      
    }, [windowSize])
    return (
        <div
            style={{
                marginRight: "auto",
                marginLeft: "auto",
                display: "flex",
                flexDirection: "column",
                height: "100vh",
            }}
            onClick={() => {
                dispatcher(setTrue());
            }}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: isLong ? "1rem" : "0.5rem", margin: isWide ? "2rem 1rem" : "1.5rem 0.5rem 0 0.5rem" }}>
                {/* <div style={{ fontSize: "2.5rem", fontWeight: "600" }}> <img style={{height:"20vh"}} src={headerImage}></img></div> */}
                {/* {isWide&&( <div style={{ fontSize: "2.5rem", fontWeight: "600",}}>SDGs かるた(仮)</div>)} */}
                <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                

                   <div style={{ width:isWide?"5rem" : "3rem", height: isWide?"5rem" : "3rem", margin: "1rem 1rem 0 0" }}></div>

                    <img src={title} style={{ height: "13vh", maxWidth: "100%", marginTop: "1rem" }}></img>
                    <Lottie
                        style={{ width: isWide?"5rem" : "3rem", height:  isWide?"5rem" : "3rem",  cursor: "pointer", margin:"1rem 1rem 0 0" }}
                        animationData={isBgmOn ? unmute : mute}
                        onClick={() => {
                            play();
                            setIsBgmOn(!isBgmOn);
                        }}
                    ></Lottie>

                </div>
                <div style={{ fontSize: isWide ? "1.5rem" : "0.9rem", textAlign: "center", fontWeight: "500" }}>
                    SDGsを遊びながら学ぶ
                    <br></br>かるた読み上げアプリです。
                    {isLong && isHeightLongerThanWidth && <br></br>}
                    <br></br>
                    南山大学SDGs普及啓発団体CLOVER<br></br> (株)CBCラジオ、ホンダロジコム(株)が<br></br>協力して作成しております。
                </div>

                {!isHeightLongerThanWidth &&
                    <div style={{ display: "flex", justifyContent: "space-evenly", gap: 0 }}>
                        <div style={{ fontSize: "1rem", textAlign: "center", width: "33%", whiteSpace: "nowrap" }}>
                            <img
                                src={umeki1}
                                alt=""
                                style={{ width: isWide ? "80%" : isLong ? "75%" : "70%", cursor: "pointer", borderRadius: "10%", boxShadow: "5px 5px 5px #ccc" }}
                                loading="eager"
                                onClick={() => {
                                    play();
                                    navigate("/play");
                                }}
                            />
                            <div style={{ textAlign: "center", fontWeight: "600", fontSize: isWide ? "1.2rem" : "0.9rem" }}>
                                <span style={{ textAlign: "center", fontWeight: "600", fontSize: isWide ? "1.2rem" : "0.9rem" }}>読み手サポート</span>
                                <br></br>モード
                            </div>
                        </div>
                        <div style={{ fontSize: "1rem", textAlign: "center", width: "33%", whiteSpace: "nowrap" }}>
                            <img
                                src={umeki2}
                                alt=""
                                style={{ width: isWide ? "80%" : isLong ? "75%" : "70%", cursor: "pointer", borderRadius: "10%", boxShadow: "5px 5px 5px #ccc" }}
                                loading="eager"
                                onClick={() => {
                                    play();
                                    navigate("/playAuto");
                                }}
                            />
                            <div style={{ textAlign: "center", fontWeight: "600", fontSize: isWide ? "1.2rem" : "0.9rem" }}>
                                <span style={{ textAlign: "center", fontWeight: "600", fontSize: isWide ? "1.2rem" : "0.9rem" }}>  おまかせ読み上げ</span> <br></br>モード
                            </div>
                        </div>
                        <div style={{ fontSize: "1rem", margin: "0 auto", width: "33%", whiteSpace: "nowrap" }}>
                            <img
                                src={learnKaruta}
                                alt=""
                                style={{ width: "80%", cursor: "pointer", borderRadius: "10%", boxShadow: "5px 5px 5px #ccc" }}
                                loading="eager"
                                onClick={() => {
                                    play();
                                    navigate("/selectNum");
                                }}
                            />
                            <div style={{ textAlign: "center", fontWeight: "600", fontSize: "1.2rem" }}>SDGsを学ぼう</div>
                        </div>


                    </div>

                }

                {isHeightLongerThanWidth &&
                    <div>
                        <div style={{ display: "flex", justifyContent: "space-evenly", gap: 0 }}>
                            <div style={{ fontSize: "1rem", textAlign: "center", width: "33%", whiteSpace: "nowrap" }}>
                                <img
                                    src={umeki1}
                                    alt=""
                                    style={{ width: isWide ? "80%" : isLong ? "75%" : "70%", cursor: "pointer", borderRadius: "10%", boxShadow: "5px 5px 5px #ccc" }}
                                    loading="eager"
                                    onClick={() => {
                                        play();
                                        navigate("/play");
                                    }}
                                />
                                <div style={{ textAlign: "center", fontWeight: "600", fontSize: isWide ? "1.2rem" : "0.9rem" }}>
                                    <span style={{ textAlign: "center", fontWeight: "600", fontSize: isWide ? "1.2rem" : "0.9rem" }}> 読み手サポート</span> <br></br>モード
                                </div>
                            </div>
                            <div style={{ fontSize: "1rem", textAlign: "center", width: "33%", whiteSpace: "nowrap" }}>
                                <img
                                    src={umeki2}
                                    alt=""
                                    style={{ width: isWide ? "80%" : isLong ? "75%" : "70%", cursor: "pointer", borderRadius: "10%", boxShadow: "5px 5px 5px #ccc" }}
                                    loading="eager"
                                    onClick={() => {
                                        play();
                                        navigate("/playAuto");
                                    }}
                                />
                                <div style={{ textAlign: "center", fontWeight: "600", fontSize: isWide ? "1.2rem" : "0.9rem" }}>
                                    <span style={{ textAlign: "center", fontWeight: "600", fontSize: isWide ? "1.2rem" : "0.9rem" }}> おまかせ読み上げ</span>   <br></br>モード
                                </div>
                            </div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ fontSize: "1rem", margin: "0 auto", width: "33%", whiteSpace: "nowrap" }}>
                                <img
                                    src={learnKaruta}
                                    alt=""
                                    style={{ width: isLong ? "75%" : "70%", cursor: "pointer", borderRadius: "10%", boxShadow: "5px 5px 5px #ccc" }}
                                    loading="eager"
                                    onClick={() => {
                                        play();
                                        navigate("/selectNum");
                                    }}
                                />
                                <div style={{ textAlign: "center", fontWeight: "600", fontSize: isWide ? "1.2rem" : "0.9rem" }}>SDGsを学ぼう</div>
                            </div>
                        </div>

                    </div>
                }

            </div>
            <React.Fragment>
                <Dialog
                    // keepMounted
                    style={{
                        width: isWide ? "36%" : "95%",
                        margin: "auto",
                    }}
                    open={openModal}
                    onClose={handleModalClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <div style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", height: "50vh", width: "100%" }}></div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleModalClose}>
                            <span>閉じる</span>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        </div>
    );
};
export default IntroducePage;
